import { render, staticRenderFns } from "./MemberTypeManagePage.vue?vue&type=template&id=78fc227a&scoped=true&"
import script from "./MemberTypeManagePage.vue?vue&type=script&lang=js&"
export * from "./MemberTypeManagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fc227a",
  null
  
)

export default component.exports